module.exports = __webpack_public_path__ + "img/arrUp.350c06d8.svg";